/**
 * Tracks the last 12 product slugs the user has viewed in localStorage.
 * Returns [recent, push, clear] — recent is reverse-chronological.
 */
import { useCallback, useEffect, useState } from "react";

const KEY = "kb_recent_products";
const MAX = 12;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
};

export default function useRecentlyViewed() {
  const [recent, setRecent] = useState(read);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setRecent(read()); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const push = useCallback((slug) => {
    if (!slug) return;
    setRecent((cur) => {
      const next = [slug, ...cur.filter((s) => s !== slug)].slice(0, MAX);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* noop */ }
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    setRecent([]);
    try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
  }, []);

  return [recent, push, clear];
}
